import { render, staticRenderFns } from "./custom-message-dialog.vue?vue&type=template&id=606c9b1c&scoped=true&"
import script from "./custom-message-dialog.vue?vue&type=script&lang=js&"
export * from "./custom-message-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c9b1c",
  null
  
)

export default component.exports